// package: proto.terrain
// file: terrain.proto

var terrain_pb = require("./terrain_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var TerrainService = (function () {
  function TerrainService() {}
  TerrainService.serviceName = "proto.terrain.TerrainService";
  return TerrainService;
}());

TerrainService.Get = {
  methodName: "Get",
  service: TerrainService,
  requestStream: false,
  responseStream: true,
  requestType: terrain_pb.TerrainRequest,
  responseType: terrain_pb.TerrainResponse
};

exports.TerrainService = TerrainService;

function TerrainServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

TerrainServiceClient.prototype.get = function get(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(TerrainService.Get, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

exports.TerrainServiceClient = TerrainServiceClient;

